export const PageRoute = {
  profile: '/manage/profile',
  Notifications: '/manage/notification-settings',
  twoFactorLogin: '/auth/two-factor',
  login: '/auth/login',
  twoFactorActivate: '/auth/two-factor-activation',
  studentPortal: '/settings/system',
  newsMessages: '/news',
};
